import { Link } from "react-router-dom";

import { useDirectorContext } from "@contexts/director";
import useDirectorRefreshStatus from "@contexts/director/useDirectorRefreshStatus";
import {
  FRESHNESS_LABELS,
  blockedReasonSentence,
  freshnessLine,
} from "./freshness";

export const REFRESH_STATUS_PATH = "/dashboard/director/refresh-status";

/**
 * Estado dos dados no cabeçalho de toda tela da Diretoria (spec `director/data-freshness`):
 * data e hora dos dados, estado (Em dia, Atrasado, Bloqueado, Atualizando), há quantos dias
 * nos estados Atrasado e Bloqueado e, no Bloqueado, o motivo com o link para o diagnóstico.
 * O estado mora no contexto da Diretoria; o polling (30 s, só em Atualizando) e o aviso de
 * dados novos (`onPublished`) vêm de `useDirectorRefreshStatus`.
 */
const DirectorFreshnessHeader = ({ onPublished, now, showDiagnosticLink = true }) => {
  const { selectedCompanyId } = useDirectorContext();
  const status = useDirectorRefreshStatus({ onPublished });
  if (!status || !FRESHNESS_LABELS[status.state]) return null;
  const reference = now ?? new Date();
  const blocked = status.state === "blocked";
  const reason = blocked ? blockedReasonSentence(status, reference) : null;
  const query = selectedCompanyId ? `?company_id=${encodeURIComponent(selectedCompanyId)}` : "";
  return <div className="director-freshness-header" data-state={status.state} aria-label="Estado dos dados">
    <p className="director-freshness-header__line">
      <span className="director-freshness-header__state" data-state={status.state}>{FRESHNESS_LABELS[status.state]}</span>
      <span className="director-freshness-header__date">{freshnessLine(status, reference)}</span>
    </p>
    {reason && <p className="director-freshness-header__reason">
      {`${reason}. `}
      {showDiagnosticLink && <Link to={`${REFRESH_STATUS_PATH}${query}`}>Ver diagnóstico</Link>}
    </p>}
  </div>;
};

export default DirectorFreshnessHeader;
